import { useCallback } from 'react';
import { Edge } from 'reactflow';
import {
  enrichMergedWithObjectDefaults,
  serializeNodeToBlobConfig,
} from '../nodeConfigUtils';
import type { ThirdPartyMode } from '../types';
import { useFlowNodePersist } from './useFlowNodePersist';

export function useThirdPartyPersist(
  edges: Edge[],
  id: string,
  flowId: string | undefined,
  setNodeState: (value: unknown) => void,
  setSaving: (saving: {
    lastSaved?: string;
    status: string;
    finished?: boolean;
    flowId?: string;
  }) => void,
  setSchema: (
    schema: Record<string, { type: string; required: boolean }>,
  ) => void,
  setBlobConfig: (value: string) => void,
) {
  const persist = useFlowNodePersist(
    edges,
    id,
    flowId,
    setNodeState,
    setSaving,
    setSchema,
  );

  const persistWithBlob = useCallback(
    (
      merged: Record<string, unknown>,
      provider: string,
      mode: ThirdPartyMode,
      _payload: Record<string, unknown>,
    ) => {
      const enriched = enrichMergedWithObjectDefaults(merged, provider, mode);
      const blobStr = serializeNodeToBlobConfig(enriched);
      setBlobConfig(blobStr);
      persist({ ...enriched, blobConfig: blobStr });
    },
    [persist, setBlobConfig],
  );

  return { persist, persistWithBlob };
}
